import { LanguageCodeEnum as e } from "./index40.mjs";
const a = "common", l = {
  ns: [a],
  defaultNS: a,
  supportedLngs: Object.values(e),
  lng: e.ENGLISH,
  fallbackLng: e.ENGLISH,
  load: "languageOnly",
  debug: !1,
  react: { useSuspense: !1 },
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1
};
export {
  a as defaultNS,
  l as defaultOptions
};
